<template>
  <div>
    <b-table
      id="user-table"
      class="px-1 rounded mt-1 bg-light-secondary"
      :items="GET_PTO_FOR_GOOD_LIST.results"
      :fields="fields"
      show-empty
      :tbody-tr-class="['tableRowClass']"
      small
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>


      <template #cell(author)="props">
        <div>
          <span
            v-if="
              props.item.author &&
              (props.item.author.first_name || props.item.author.last_name)
            "
            >{{ props.item.author.first_name }}
            {{ props.item.author.last_name }}</span
          >
        </div>
      </template>

      <template #cell(actions)="props">
        <div class="d-flex align-items-center justify-content-center">
          <b-form-checkbox v-model="selected" :value="props.item.id">
          </b-form-checkbox>
        </div>
      </template>
    </b-table>


    <Pagination @refresh="FETCH_PTO_FOR_GOOD_LIST" />
    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-button @click="addToReport" variant="success"> {{$t('save')}} </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
  BButton,
  BFormGroup,
  BBadge,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Pagination from "@/components/Pagination.vue";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BBadge,
    Pagination,
  },
  data() {
    return {
      selected: [],
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "courses.type",
          key: "material.goods.product.title",
          thClass: "tableHeadClass",
        },
        {
          label: "product",
          key: "material.goods.value",
          thClass: "tableHeadClass",
        },
        {
          label: "object",
          key: "rc_object",
          thClass: "tableHeadClass",
        },
        {
          label: "unit_of_measurement",
          key: "material.goods.unity",
          thClass: "tableHeadClass",
        },
        {
          label: "amount",
          key: "quantity",
          thClass: "tableHeadClass",
        },
        {
          label: "date",
          key: "created_at",
          formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
          thClass: "tableHeadClass",
        },
        {
          label: "master",
          key: "author",
          thClass: "tableHeadClass",
        },
        {
          label: "note",
          key: "material.note",
          thClass: "tableHeadClass",
        },
        {
          label: "сontract_number",
          key: "contract_number",
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
    };
  },
  mixins: [check, loader],
  methods: {
    ...mapActions("pto", ["FETCH_PTO_FOR_GOOD_LIST"]),

    ...mapActions("contacts", ["CREATE_REPORT_PTO", "FETCH_ALL_REPORT_LIST"]),

    addToReport() {
      try {
        this.CREATE_REPORT_PTO({
          id: this.$route.params.id,
          data: {
            pto_list: this.selected,
          },
        }).then((res) => {
          this.$_okToast();
          this.FETCH_ALL_REPORT_LIST();
          this.$router.push({ name: "report" });
        });
      } catch (err) {
        this.$_errToast(err);
      }
    },
  },

  computed: {
    ...mapGetters("pto", ["GET_PTO_FOR_GOOD_LIST"]),
  },
  async mounted() {
    await this.$_loaderStart();
    await this.FETCH_PTO_FOR_GOOD_LIST({ report: 0 });
  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
};
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>